import { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Api from "../../../api/Api";

const resetPassword = async(data) => {
    try {
        const response = await Api({
            method:"post",
            url:`/auth/reset_password`,
            data:data
        });
        alert("Ожидайте письмо для сброса пароля");
    } catch (error) {
        alert(`Ошибка при отправке письма для сброса пароля \n ${error}`);
    }
}

const RestorePasswordModal = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmitEmail = async() => {
        if(document.getElementById("restore_email_field").value.trim()!==""){
            const data = {email:document.getElementById("restore_email_field").value};
            await resetPassword(data);
        }else{
            alert("Введите email!")
        }
    }

    return(
        <>
            <Button 
                variant="light"
                className="free-btn"  
                onClick={handleShow}>Не помню пароль</Button>

            <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Восстановление пароля</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Text>Введите рабочую почту, чтобы получить письмо для сброса пароля.</Form.Text>
                <Form.Control 
                id="restore_email_field"
                type="text" 
                placeholder="Введите рабочую почту..." 
                required/>
                <Row className="d-flex justify-content-end flex-wrap mt-2">
                    <Col>
                        <Button 
                            onClick={()=>handleSubmitEmail()}
                            variant="primary" 
                            className="free-btn">Отправить</Button>
                    </Col>
                </Row>
            </Modal.Body>
            </Modal>
        </>
    )
}

export default RestorePasswordModal;